import { API_GUEST_HEADERS, API_HEADERS, REACT_APP_LIFERAY_HOST } from "./utils";

class PickListService {
    constructor() {
        this.cache = new Map();
        this.cacheTimeout = 60000; // 1 minute
    }
    /**
     * Méthode pour obtenir les valeurs d'une liste
     */
    async getPickListValues(listId) {
        try {
            const url = `${REACT_APP_LIFERAY_HOST}/o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/${listId}?fields=listTypeEntries`;
            const response = await fetch(url, {
                method: 'GET',
                headers: API_HEADERS,
            });
            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            const data = await response.json();
            // console.log(data);

            return data.listTypeEntries;
        } catch (error) {
            console.error("Erreur lors de la récupération des informations de l'utilisateur:", error);
            return {
                error: true,
                message: "Erreur lors de la création du compte",
            };
        }
    }
}
export default PickListService;